import { findMentionMatches } from "./mentions.ts";

export interface PromptNode {
  type: string;
  text?: string;
  attrs?: Record<string, unknown>;
  content?: PromptNode[];
}

/** UI-only document. Persist/send canonical plain text, never editor HTML. */
export function promptDocument(value: string): PromptNode {
  const content: PromptNode[] = [];
  const appendText = (text: string) => {
    text.split("\n").forEach((line, i) => {
      if (i) content.push({ type: "hardBreak" });
      if (line) content.push({ type: "text", text: line });
    });
  };
  let last = 0;
  for (const match of findMentionMatches(value)) {
    appendText(value.slice(last, match.start));
    content.push({ type: "promptReference", attrs: { token: `@${match.slug}` } });
    last = match.end;
  }
  appendText(value.slice(last));
  return { type: "doc", content: [{ type: "paragraph", content }] };
}

export function promptText(node: PromptNode): string {
  if (node.type === "text") return node.text ?? "";
  if (node.type === "hardBreak") return "\n";
  if (node.type === "promptReference") return String(node.attrs?.token ?? "");
  return (node.content ?? []).map(promptText).join(node.type === "doc" ? "\n" : "");
}
